module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_Normal__And__Centre_Alignment"
  }, [_c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-size": "0.83em"
    }
  }, [_vm._v("© 2007 Academy Chicago Publishers")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Centre_Alignment"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Centre_Alignment"
  }, [_c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-size": "0.83em"
    }
  }, [_vm._v("Published in 2007 by ")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Centre_Alignment"
  }, [_c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-size": "0.83em"
    }
  }, [_vm._v("Academy Chicago Publishers")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Centre_Alignment"
  }, [_c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-size": "0.83em"
    }
  }, [_vm._v("363 West Erie Street, 4W")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Centre_Alignment"
  }, [_c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-size": "0.83em"
    }
  }, [_vm._v("Chicago, Illinois 60654")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Centre_Alignment"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Centre_Alignment"
  }, [_c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-size": "0.83em"
    }
  }, [_vm._v("First published in 1930")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Centre_Alignment"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Centre_Alignment"
  }, [_c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-size": "0.83em"
    }
  }, [_vm._v("Printed and bound in the U.S.A.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Centre_Alignment"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Centre_Alignment"
  }, [_c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-size": "0.83em"
    }
  }, [_vm._v("All rights reserved.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Centre_Alignment"
  }, [_c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-size": "0.83em"
    }
  }, [_vm._v("No part of this book may be reproduced in any form ")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Centre_Alignment"
  }, [_c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-size": "0.83em"
    }
  }, [_vm._v("without the express written permission of the publisher.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Centre_Alignment"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Centre_Alignment"
  }, [_c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-size": "0.83em"
    }
  }, [_vm._v("Library of Congress data on file with publisher.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Centre_Alignment"
  }, [_c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-size": "0.83em"
    }
  }, [_vm._v("eBook ISBN: 978-0-89733-662-8")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bddcee48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0002.vue
// module id = 63
// module chunks = 0